import { render, staticRenderFns } from "./income-index.vue?vue&type=template&id=2c1f04fb&scoped=true&lang=html&"
import script from "./income-index.vue?vue&type=script&lang=js&"
export * from "./income-index.vue?vue&type=script&lang=js&"
import style0 from "./income-index.vue?vue&type=style&index=0&id=2c1f04fb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f04fb",
  null
  
)

export default component.exports